module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074b8_banner_800x600.f8bcbe20.png";